// extracted by mini-css-extract-plugin
export default {"collaborationSpace":"CollaborationRestaurant_collaborationSpace__ALQlR","title":"CollaborationRestaurant_title__PnOMm"};